<div class="wrapper">
    <footer class="realto-footer">
        <div class="left">
            <app-footer-settings-menu></app-footer-settings-menu>
            <p class="copyright">{{ currentYear }} © {{ 'AllRightsReserved' | localize }}</p>
            <p class="version">{{ 'Version' | localize }}: {{ currentVersion }}</p>
        </div>
        <div class="right">
            <a [href]="'bug@realto.group' | email">{{ 'Help' | localize }}</a>
            <a [href]="'bug@realto.group' | email">{{ 'Contact' | localize }}</a>
        </div>
    </footer>
</div>
